import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {ButtonGroupSpacer} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {Dialog} from '../../../../../libs/shared/ui/src/components/dialogs/dialog';
import {DialogContent} from '../../../../../libs/shared/ui/src/components/dialogs/dialogContent';
import {DialogFooter} from '../../../../../libs/shared/ui/src/components/dialogs/dialogFooter';
import {DialogHeader} from '../../../../../libs/shared/ui/src/components/dialogs/dialogHeader';

/*
 * Props.
 */

interface LensesConfirmHideDialogProps {
  onRequestClose: () => void;
  onConfirmHide: () => void;
}

/*
 * Style.
 */

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

/*
 * Component.
 */

export const LensesConfirmHideDialog: FC<LensesConfirmHideDialogProps> = ({
  onConfirmHide,
  onRequestClose,
}) => {
  const onHide = () => {
    onRequestClose();
    onConfirmHide();
  };
  const onCloseDialog = () => {
    onRequestClose();
  };

  return (
    <Dialog onRequestClose={onCloseDialog}>
      <DialogHeader
        onRequestClose={onCloseDialog}
        title={<Trans id="lenses-workspace-hide-dialog-title">Hide in sidebar?</Trans>}
      />
      <DialogContent>
        <Trans id="lenses-workspace-hide-dialog-disclaimer">
          Are you sure you want to hide &quot;Views&quot; in your sidebar? You can bring this section back by
          adding an existing view or creating a new one from &quot;Edit sidebar&quot;.
        </Trans>
      </DialogContent>
      <DialogFooter>
        <StyledButtonGroup>
          <ButtonGroupSpacer />
          <Button onClick={onCloseDialog}>
            <Trans id="lenses-workspace-hide-dialog-cancel-button">Cancel</Trans>
          </Button>
          <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onHide}>
            <Trans id="lenses-workspace-hide-dialog-delete-button">Hide</Trans>
          </Button>
        </StyledButtonGroup>
      </DialogFooter>
    </Dialog>
  );
};
